import { batchLookupToCsvRows } from './batchLookupToCsvRows'
import { BatchCsvFilterOptions, makeBatchLookupCsv } from './makeBatchLookupCSV'

type BatchCsvs = BatchCsvFilterOptions | 'all'

export const makeBatchLookupCsvs = (
  batchLookupValues: Parameters<typeof batchLookupToCsvRows>[0],
  batchAliasAssignments: Parameters<typeof batchLookupToCsvRows>[1]
) => {
  const csvRows = batchLookupToCsvRows(batchLookupValues, batchAliasAssignments)

  const filters = [undefined, 'needs_tlc', 'no_match', 'fix_category'] as const

  const csvs: { [key in BatchCsvs]?: string | null } = {}

  filters.forEach((filter) => (csvs[filter || 'all'] = makeBatchLookupCsv(csvRows, { filter })))

  return csvs
}
